export default __webpack_public_path__ + "static/media/iconArrowLeft.f9520964.svg";